import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export function useStatsAccess() {
  const [a, setA] = useState(null);
  useEffect(() => { api.get("/stats/access").then((r) => setA(r.data)).catch(() => setA({ allowed: false })); }, []);
  return a;
}

export function StatsTabs() {
  const cls = ({ isActive }) => `px-3 py-1.5 text-xs font-medium rounded transition-colors ${isActive ? "bg-norea-primary text-white" : "text-norea-textMuted hover:text-norea-text"}`;
  return (
    <div className="mb-5 inline-flex items-center gap-0.5 bg-white border border-norea-border rounded-md p-0.5" data-testid="stats-tabs">
      <NavLink to="/statistiques" end className={cls} data-testid="stats-tab-dossiers">Dossiers</NavLink>
      <NavLink to="/statistiques/sav" className={cls} data-testid="stats-tab-sav">SAV & litiges</NavLink>
    </div>
  );
}

export function StatsDenied() {
  return <div className="card-flat p-8 text-sm text-norea-textMuted" data-testid="stats-denied">Les statistiques sont réservées aux administrateurs et aux utilisateurs autorisés (Paramètres → Statistiques).</div>;
}

export function StatsAccessCard({ access }) {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [sel, setSel] = useState(access?.users || []);
  useEffect(() => { if (user?.role === "admin") api.get("/users").then((r) => setUsers((r.data.items || r.data || []).filter((u) => u.role !== "admin"))).catch(() => {}); }, [user]);
  if (user?.role !== "admin") return null;
  const toggle = async (email) => {
    const next = sel.includes(email) ? sel.filter((x) => x !== email) : [...sel, email];
    try { setSel((await api.put("/stats/access", { users: next })).data.users); toast.success("Accès aux statistiques mis à jour"); } catch { toast.error("Erreur"); }
  };
  return (
    <section className="card-flat p-4 mb-5" data-testid="stats-access-card">
      <div className="text-sm font-medium mb-1">Accès aux statistiques</div>
      <div className="text-[11px] text-norea-textMuted mb-2">Les administrateurs y ont toujours accès. Cochez les autres utilisateurs autorisés.</div>
      <div className="flex flex-wrap gap-2">
        {users.length === 0 && <span className="text-xs italic text-norea-textMuted">Aucun autre utilisateur</span>}
        {users.map((u) => (
          <label key={u.email} className="inline-flex items-center gap-1.5 text-xs border border-norea-border rounded px-2 py-1 cursor-pointer">
            <input type="checkbox" checked={sel.includes(u.email)} onChange={() => toggle(u.email)} data-testid={`stats-access-${u.email}`} />{u.name || u.email}
          </label>
        ))}
      </div>
    </section>
  );
}
